import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import React, { Component } from "react";
// import "react-responsive-modal/styles.css";
import { Image, Form, Modal, Button, Row, Col } from "react-bootstrap";
import { ReusableOnboardingMapButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";
import { PAYMENT_STATUS } from "../../../../enums/OrderEnums";

export class Fillter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      not_confirmed: false,
      confirmed_user: false,
      seatingStatus: "",
      errors: {},
      confirmuser: "abc",
      releventOptionSelect: 3,
      allSeatingArea: [],
      seatingPreferenceData: "",
      paymentData: "",
      eventType: "",
      locationPage: "",
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      (!isEmpty(nextProps?.allSeatingAreas) &&
        !isEmpty(nextProps.seatingArea)) ||
      !isEmpty(nextProps?.history?.location?.state?.actionBy)
    ) {
      let filterSeating = nextProps?.allSeatingAreas?.filter((seat) =>
        nextProps?.seatingArea.includes(seat?._id)
      );
      return {
        allSeatingArea: filterSeating,
        locationPage: nextProps?.history?.location?.state?.actionBy,
      };
    } else {
      return null;
    }
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  resetFilter = (e) => {
    this.setState({
      not_confirmed: false,
      confirmed_user: false,
    });
  };

  /***************************
   * @DESC Big Button Handler
   ***************************/
  bigButtonHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      seatingStatus: type,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  onSubmitHandler = (e) => {
    e.preventDefault();
    const formData = {
      seatingStatus: this.state.seatingStatus,
    };
  };

  seatingButtonClick = (data) => {
    this.setState({ seatingPreferenceData: data });
  };

  paymentButtonClick = (data) => {
    this.setState({ paymentData: data });
    this.props.onPaymentButtonDataClick(data);
  };

  eventTypeButtonClick = (data) => {
    this.setState({ eventType: data });
  };

  render() {
    const {
      open,
      seatingStatus,
      confirmuser,
      releventOptionSelect,
      allSeatingArea,
      seatingPreferenceData,
      paymentData,
      eventType,
      locationPage,
    } = this.state;
    return (
      <React.Fragment>
        <div
          onClick={this.props.onOpenModal}
          className="d-flex align-items-center justify-content-between cursor"
        >
          <Image
            alt="filter"
            title="filter"
            width="80px"
            src={require("../../../../assets/images/seatingImages/filter.svg")}
          />
          {/* <div className="f12-500 text-blue mx-2">Filter</div>
          <i className="fa fa-angle-down text-blue" aria-hidden="true"></i> */}
        </div>
        <Modal show={this.props.open} onHide={this.props.onCloseModal} centered>
          <Modal.Header className="border-0" closeButton>
            <Modal.Title className="f24_700_HelveticaNeue">Filter</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={`${this.props.origin === "events" ? "pt-0" : ""}`}
          >
            {this.props.origin === "events" ? (
              <React.Fragment>
                <Row>
                  <Col md={12}>
                    <div className="f16-500 pb-1 pt-0">
                      Please select relevent option
                    </div>
                    <FormControl component="fieldset">
                      <FormGroup aria-label="position" row>
                        {locationPage === "pendingPage" ||
                        locationPage === "historyPage" ||
                        locationPage === "allPage" ? (
                          <FormControlLabel
                            value="yes"
                            control={
                              <Radio
                                // color="primary"
                                checked={releventOptionSelect === 0}
                                onClick={() => {
                                  this.setState({ releventOptionSelect: 0 });
                                }}
                              />
                            }
                            label="Select Event Type"
                            labelPlacement="Select Event Type"
                          />
                        ) : null}
                        <FormControlLabel
                          value="no"
                          control={
                            <Radio
                              // color="primary"
                              checked={releventOptionSelect === 1}
                              onClick={() => {
                                this.setState({ releventOptionSelect: 1 });
                              }}
                            />
                          }
                          label="Select Seating Preference"
                          labelPlacement="Select Seating Preference"
                        />
                        {locationPage === "pendingPage" ||
                        locationPage === "historyPage" ||
                        locationPage === "allPage" ||
                        locationPage === "ticketPage" ? (
                          <FormControlLabel
                            value="no"
                            control={
                              <Radio
                                // color="primary"
                                checked={releventOptionSelect === 2}
                                onClick={() => {
                                  this.setState({ releventOptionSelect: 2 });
                                }}
                              />
                            }
                            label="Select Payment Status"
                            labelPlacement="Select Payment Status"
                          />
                        ) : null}
                      </FormGroup>
                    </FormControl>
                  </Col>
                </Row>
                {releventOptionSelect === 0 ? (
                  <Row>
                    <div
                      className={`col-4 mb-2`}
                      onClick={() => this.eventTypeButtonClick("RSVP")}
                    >
                      <div
                        className={`${
                          eventType === "RSVP"
                            ? "w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                            : "w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        }`}
                      >
                        <span
                          className="para-data-icon"
                          style={{ color: "#212121" }}
                        >
                          RSVP
                        </span>
                      </div>
                    </div>
                    <div
                      className={`col-4 mb-2`}
                      onClick={() => this.eventTypeButtonClick("TICKET_BOOKED")}
                    >
                      <div
                        className={`${
                          eventType === "TICKET_BOOKED"
                            ? "w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                            : "w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        }`}
                      >
                        <span
                          className="para-data-icon"
                          style={{ color: "#212121" }}
                        >
                          TICKET BOOKED
                        </span>
                      </div>
                    </div>
                    <div className="col-12 pt-4 d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 "
                        onClick={() => {
                          this.setState({
                            eventType: "",
                            seatingPreferenceData: "",
                            paymentData: "",
                          });
                          this.props.resetEventTypeFilter("");
                        }}
                      >
                        Reset Filter
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={() =>
                          this.props.selectEventTypeFilter(eventType)
                        }
                      >
                        Apply Filter
                      </Button>
                    </div>
                  </Row>
                ) : releventOptionSelect === 1 ? (
                  <Row>
                    <Col md={12}>
                      <div className="f16-500 pb-1 pt-3">
                        Seating Preference
                      </div>
                      <div className="f12-400 pb-3">
                        Seating is a subject to availability. Your Preference
                        will be considered.
                      </div>
                    </Col>
                    <Col md={12}>
                      <Form.Row>
                        {allSeatingArea &&
                          allSeatingArea.map((item, index) => (
                            <div
                              className={`col-4 mb-2`}
                              key={index}
                              onClick={() =>
                                this.seatingButtonClick(item?.title)
                              }
                            >
                              <div
                                className={`${
                                  seatingPreferenceData === item?.title
                                    ? "w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                                    : "w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                                }`}
                              >
                                <img
                                  src={item?.icon}
                                  alt="icon"
                                  title={item?.title}
                                />
                                <span
                                  className="para-data-icon"
                                  style={{ color: "#212121" }}
                                >
                                  {item?.title}
                                </span>
                              </div>
                            </div>
                          ))}
                      </Form.Row>
                    </Col>
                    <div className="col-12 pt-4 d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 "
                        onClick={() => {
                          this.setState({
                            eventType: "",
                            seatingPreferenceData: "",
                            paymentData: "",
                          });
                          this.props.resetEventTypeFilter("");
                        }}
                      >
                        Reset Filter
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={() =>
                          this.props.onSeatingClick(seatingPreferenceData)
                        }
                      >
                        Apply Filter
                      </Button>
                    </div>
                  </Row>
                ) : releventOptionSelect === 2 ? (
                  <Row>
                    {PAYMENT_STATUS.map((data, index) => (
                      <div
                        className={`col-4 mb-2`}
                        key={index}
                        onClick={() => this.paymentButtonClick(index)}
                      >
                        <div
                          className={`${
                            paymentData === index
                              ? "w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                              : "w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          }`}
                        >
                          <span
                            className="para-data-icon"
                            style={{ color: "#212121" }}
                          >
                            {data}
                          </span>
                        </div>
                      </div>
                    ))}
                    <div className="col-12 pt-4 d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 "
                        onClick={() => {
                          this.setState({
                            eventType: "",
                            seatingPreferenceData: "",
                            paymentData: "",
                          });
                          this.props.resetEventTypeFilter("");
                        }}
                      >
                        Reset Filter
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={() =>
                          this.props.onStatusPaymentClick(paymentData)
                        }
                      >
                        Apply Filter
                      </Button>
                    </div>
                  </Row>
                ) : null}
              </React.Fragment>
            ) : (
              // <div>
              //   <FormControl component="fieldset">
              //     <FormGroup aria-label="position" row>
              //       <FormControlLabel
              //         value="yes"
              //         control={
              //           <Checkbox
              //             color="primary"
              //             checked={confirmuser === true}
              //             onClick={() => {
              //               this.setState({ confirmuser: true });
              //             }}
              //           />
              //         }
              //         label="Confirmed by User"
              //         labelPlacement="Confirmed by User"
              //       />
              //       <FormControlLabel
              //         value="no"
              //         control={
              //           <Checkbox
              //             color="primary"
              //             checked={confirmuser === false}
              //             onClick={() => {
              //               this.setState({ confirmuser: false });
              //             }}
              //           />
              //         }
              //         label="Not Confirmed by User"
              //         labelPlacement="Not Confirmed by User"
              //       />
              //     </FormGroup>
              //   </FormControl>
              //   <div className="pt-4 d-flex align-items-center">
              //     <Button
              //       variant="outline-secondary"
              //       className="btn-lg mr-4 px-5 "
              //       onClick={() => {
              //         this.setState({ confirmuser: "" });
              //         this.props.resetFilter(0);
              //       }}
              //     >
              //       Reset Filter
              //     </Button>
              //     <Button
              //       variant="danger"
              //       className="btn-lg px-5"
              //       onClick={() =>
              //         this.props.onStatusClick(confirmuser ? 1 : 2)
              //       }
              //     >
              //       Apply Filter
              //     </Button>
              //   </div>
              // </div>
              <>
                <div className="pb-4 f16-500">
                  Select one relevant option from below
                </div>
                <Form noValidate onSubmit={this.onSubmitHandler}>
                  <div className="pt-4 d-flex flex-wrap align-items-center">
                    <button
                      type="button"
                      className={`enFilterButton mr-3 mb-3 ${
                        this.props.seatingStatus === "All" ? "active" : ""
                      }`}
                      // onClick={(e) => this.bigButtonHandler(e, "All")}
                      onClick={this.props.onClickAll}
                    >
                      All
                    </button>
                    <button
                      type="button"
                      className={`enFilterButton mr-3 mb-3 ${
                        this.props.seatingStatus === "Walk-in" ? "active" : ""
                      }`}
                      // onClick={(e) => this.bigButtonHandler(e, "Walk-in")}
                      onClick={this.props.onClickWalkIn}
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/walkin.svg")}
                        alt="View"
                        title="View"
                        width="12px"
                        className="mr-2"
                      />
                      Walk-in
                    </button>
                    <button
                      type="button"
                      className={`enFilterButton mr-3 mb-3 ${
                        this.props.seatingStatus === "Waitlist" ? "active" : ""
                      }`}
                      // onClick={(e) => this.bigButtonHandler(e, "Waitlist")}
                      onClick={this.props.onClickWaitlist}
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/clock.svg")}
                        alt="View"
                        title="View"
                        width="15px"
                        className="mr-2"
                      />
                      Waitlist
                    </button>
                    <button
                      type="button"
                      className={`enFilterButton mr-3 mb-3 ${
                        this.props.seatingStatus === "Reservation"
                          ? "active"
                          : ""
                      }`}
                      // onClick={(e) => this.bigButtonHandler(e, "Reservation")}
                      onClick={this.props.onClickReservation}
                    >
                      <Image
                        src={require("../../../../assets/images/ActionImages/online-booking.svg")}
                        alt="View"
                        title="View"
                        width="15px"
                        className="mr-2"
                      />
                      Reservation
                    </button>
                  </div>

                  <div className="pt-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 "
                      onClick={this.props.resetFilter}
                    >
                      Reset Filter
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={this.props.onStatusClick}
                    >
                      Apply Filter
                    </Button>
                  </div>
                </Form>
              </>
            )}
          </Modal.Body>

          {/* <div className="reason-for-cancellation main-filter">
            <Form noValidate onSubmit={this.onSubmitHandler}>
              <Row className="checkbox-button">
                <Col>
                  <Form.Group controlId="formBasicCheckboxone">
                    <Form.Check
                      name="not_confirmed"
                      value={this.state.not_confirmed}
                      onChange={this.onChange}
                      className="label-text-orange"
                      inline
                      type="checkbox"
                      label="Not Confirmed by User"
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="formBasicCheckboxtwo">
                    <Form.Check
                      name="confirmed_user"
                      value={this.state.confirmed_user}
                      onChange={this.onChange}
                      className="label-text-green"
                      inline
                      type="checkbox"
                      label="Confirmed by User"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="">
                <PopupInsideButton
                  buttonClass={
                    seatingStatus === "All"
                      ? "popup-inside-button popup-inside-buttonactive"
                      : "popup-inside-button"
                  }
                  buttonText="All"
                  buttonType="button"
                  onClick={(e) => this.bigButtonHandler(e, "All")}
                />
                <PopupInsideButton
                  display={true}
                  buttonImage={require("../../../../assets/images/ActionImages/walking-img.svg")}
                  title="Walk-in"
                  buttonClass={
                    seatingStatus === "Walk-in"
                      ? "popup-inside-button popup-inside-buttonactive"
                      : "popup-inside-button"
                  }
                  buttonText="Walk-in"
                  buttonType="button"
                  onClick={(e) => this.bigButtonHandler(e, "Walk-in")}
                />
                <PopupInsideButton
                  display={true}
                  buttonImage={require("../../../../assets/images/ActionImages/clock-circular-outline.svg")}
                  title="Waitlist"
                  buttonClass={
                    seatingStatus === "Waitlist"
                      ? "popup-inside-button popup-inside-buttonactive"
                      : "popup-inside-button"
                  }
                  buttonText="Waitlist"
                  buttonType="button"
                  onClick={(e) => this.bigButtonHandler(e, "Waitlist")}
                />
                <PopupInsideButton
                  display={true}
                  buttonImage={require("../../../../assets/images/ActionImages/online-booking.svg")}
                  title="Reservation"
                  buttonClass={
                    seatingStatus === "Reservation"
                      ? "popup-inside-button popup-inside-buttonactive border-bottom-0"
                      : "popup-inside-button border-bottom-0"
                  }
                  buttonText="Reservation"
                  buttonType="button"
                  onClick={(e) => this.bigButtonHandler(e, "Reservation")}
                />
              </div>
              <div className="bottom-filter d-flex justify-content-between">
                <button
                  type="button"
                  className="custom-button"
                  onClick={this.resetFilter}
                >
                  Reset Filter
                </button>
                <button
                  type="button"
                  className="custom-button"
                  onClick={this.onCloseModal}
                >
                  Apply Filter
                </button>
              </div>
            </Form>
          </div> */}
        </Modal>
      </React.Fragment>
    );
  }
}

Fillter.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  allSeatingAreas: state.category.seating_area,
  seatingArea: state.onboarding?.onboard_subscription_details?.casual_dining
    ? state.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.seating?.general_seating?.seating_areas
    : state.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.seating?.general_seating
        ?.seating_areas,
});

export default connect(mapStateToProps, {})(withRouter(Fillter));
